/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section Wrapper
 */

// Components
import SectionHeader from './SectionHeader';

// Styles
import './style.scss'

function Section(props) {
    const sectionData = props.sectionData;

    return(
        <section id={sectionData.id} className={sectionData.className}>
            {
                (sectionData.sectionOverlay) ? <div className="content-overlay"></div> : null
            }
            <SectionHeader sectionHeader={sectionData.sectionHeader} />
            
            {sectionData.component}
        </section>
    );

}

export default Section;